export const ARTICLE_SUMMARY_MAX_LENGTH = 300

const SENTENCE_END = /[.!?](?=\s|$)|[。！？]/g
const TRAILING_JUNK = /[\s,;:.-]+$/

// Keeps whole sentences when one fits, else cuts at a word, so a clipped summary never ends mid-word.
export function clampArticleSummary(
	summary: string,
	max: number = ARTICLE_SUMMARY_MAX_LENGTH,
): string {
	const clean = summary.replace(/\s+/g, " ").trim()
	if (clean.length <= max) return clean

	let sentenceEnd = -1
	for (const match of clean.slice(0, max + 1).matchAll(SENTENCE_END)) {
		if (match.index < max) sentenceEnd = match.index + 1
	}
	if (sentenceEnd >= max / 2) return clean.slice(0, sentenceEnd)

	const cut = clean.slice(0, max - 1)
	const lastSpace = cut.lastIndexOf(" ")
	const words = lastSpace >= max / 2 ? cut.slice(0, lastSpace) : cut
	return `${words.replace(TRAILING_JUNK, "")}…`
}
